import React, { useEffect, useState } from "react";
import { EaseDrawer } from "../../../libs/EaseDrawer";
import { Text1, Text3, Text4 } from "../../../styles";
import { Button, Icon, Tooltip, Spin } from "antd";
import './index.scss';
import { handleApiExceptions, printRupee } from "../../../app_methods";
import { MerchantService } from "../../../services";
import { LoadAccountModal } from "./load_amount_modal";
import { LoadEditAccountModal } from "./load_edit_modal";
import { connect } from 'react-redux';
import { updateCurrentUserAction } from '../../../redux/actions';
import { CreateAccountModal } from '../../Common';
import { EaseTable } from "../../../libs/EaseTable";
import { Merchant } from "../../../models";
import { PermissionHoc } from "../../HOC";

const AllotedAccountWriteIcon = PermissionHoc(Icon, "ALLOTED_ACCOUNT_WRITE", { is_component: true, fallbackComponent: null })
const AllotedAccountWriteButton = PermissionHoc(Button, "ALLOTED_ACCOUNT_WRITE", { is_component: true, fallbackComponent: null })


const AllotedConnectedBankingDrawer = (props) => {
    const { merchant } = props;
    const [shared_connected_banking_accounts, setshared_connected_banking_accounts] = useState([])
    const [showAmountLoadModal, setShowAmountLoadModal] = useState(false)
    const [showEditAccountModal, setShowEditAccountModal] = useState(false)
    const [fetchingBalance, setFetchingBalance] = useState('')
    const [showCreateAccountModal, setShowCreateAccountModal] = useState(false);
    const [selectedAccount, setSelectedAccount] = useState('')
    const [isfetchingAccounts, setFetchingAccounts] = useState(false)

    useEffect(() => {
      if (props.visible){
        fetchAllotedAccounts()
      }
    }, [props.visible])
    
    const toggleAmountLoadModal = (account) => {
        setSelectedAccount(account)
        setShowAmountLoadModal(!showAmountLoadModal);
    };

    const editAccountModal = (account) => {
        setSelectedAccount(account)
        setShowEditAccountModal(!showEditAccountModal)
    }

    const toggleCreateAccountModal = () => {
        setShowCreateAccountModal(!showCreateAccountModal)
    }

    const fetchBlance = async (recordId) => {
        setFetchingBalance(recordId);
        const response = await MerchantService.get_balance({ id: recordId });
        if (!response.success) {
            handleApiExceptions(response);
            setFetchingBalance('');
            return;
        }
        let vas = shared_connected_banking_accounts
        vas.map((ac) => ((ac.id == recordId) ? ac.balance = response.data.balance : ac))
        setshared_connected_banking_accounts([...vas])
        setFetchingBalance('');

    };

    const fetchMerchantInfo = () => {
        MerchantService.fetch().then((response) => {
            if (response.success) props.updateCurrentUser(response.data.merchant);
        });
    };

    const fetchAllotedAccounts = async () => {
        setFetchingAccounts(true);
        let params={isSubWallet:props.isSubWallet,master_virtual_account:props.selectedVirtualAccount?.id}
        const response = await Merchant.get_alloted_accounts(merchant.id,params);
        if (!response.success) {
            handleApiExceptions(response);
            setFetchingAccounts(false);
            return;
        }
        let vas = response.data.virtual_accounts
        setshared_connected_banking_accounts([...vas])
        setFetchingAccounts(false);
    }

    const deactivateAccount= async (record)=>{
        let params={account_id:record.id}
        const response = await Merchant.deactivateAccount(params);
        if (!response.success) {
            handleApiExceptions(response);
            setFetchingAccounts(false);
            return;
        }
        fetchAllotedAccounts()
    }

    const totalFunds = shared_connected_banking_accounts.reduce((total, account) => total + (parseFloat(account.balance) || 0), 0);

    const columns = [
        {
            title: 'Account Number',
            key: 'virtual_account_number',
            render: (record) => <>
            <div><Text4>{record.parent_account_number}</Text4></div>
            <div><Text4 type='secondary'>{record.label}</Text4></div>
            <br/>   
            <div><Text4 type='secondary'>{record.label_name}</Text4></div>
            </>
        },
        {
            title: 'Balance',
            key: 'balance',
            render: (record) => <div>{printRupee(record.balance) || "---"}
            </div>
        },
        {
            title: 'Actions',
            key: 'action',
            render: (record) => <div>
                <span className="justify-content-centre">
                    <Tooltip title="Get Updated Balance">
                        <Icon
                            className="mr-3"
                            type="sync"
                            spin={record.id == fetchingBalance}
                            onClick={() => { (record.id != fetchingBalance) && fetchBlance(record.id) }}
                        />
                    </Tooltip>
                    <Tooltip title="Manage funds">
                        <AllotedAccountWriteIcon
                            className="mr-3"
                            type="bank"
                            onClick={() => toggleAmountLoadModal(record)}
                        />
                    </Tooltip>
                   
                    {record.balance==0 && props.isSubWallet ?<Tooltip title={record.status=='active'?"Deactivate" :'Activate'}>
                        <Icon
                            className="mr-3"
                            type={record.status=='active'?"close-circle" :'check-circle'}
                            onClick={() => deactivateAccount(record)}
                            style={{ color: record.status == 'active' ? 'red' : 'green' }}
                        />
                    </Tooltip> : null}
                    <Tooltip title="Edit">
                        <Icon
                            className="mr-3"
                            type="edit"
                            onClick={() => editAccountModal(record)}
                        />
                    </Tooltip>
                </span>
            </div>
        },

    ];

    const renderTitle = () => {
        return (
            <div className="mb-4">
                <Text1 className="d-block" strong>{props.isSubWallet? 'Sub Wallets':'Allotted Accounts'}</Text1>
                {props.isSubWallet && <div className="mt-2"><Text4>Total Funds: {printRupee(totalFunds)}</Text4></div>}
            </div>
        )
    };


    const renderSharedAccountBankDetails = () => {
        
        return (
            <>
                <div className="d-flex justify-content-end">
                    <AllotedAccountWriteButton size="small" className='float-right' onClick={toggleCreateAccountModal}>Create Account</AllotedAccountWriteButton>
                </div>

                <EaseTable
                    className="border-top border-left border-right rounded"
                    columns={columns}
                    data={shared_connected_banking_accounts}
                    size="middle"
                    pagination={false}
                />
            </>
        )
    }

    return (
        <EaseDrawer
            className="merchant-details-wrapper"
            title={false}
            width={550}
            visible={props.visible}
            // onOpen={fetchAllotedAccounts}
            onClose={props.toggleAllotedConnectedBankingDrawer}
            centered
            hideHeader
            hideFooter
            destroyOnClose
        >
            <>{isfetchingAccounts ?
                <div style={{ width: "100%", height: "84vh" }} className="d-flex justify-content-center align-items-center">
                    <Spin className="mt-2" tip="Loading..." spinning={isfetchingAccounts} />
                </div> :
                <div className="mt-3">
                    {renderTitle()}
                    {renderSharedAccountBankDetails()}
                </div>
            }

            </>

            <LoadAccountModal
                visible={showAmountLoadModal}
                merchant={merchant}
                toggleAmountLoadModal={toggleAmountLoadModal}
                toggleDetailsDrawer={props.toggleDetailsDrawer}
                account={selectedAccount}
                fetchBlance={fetchBlance}
                fetchMerchantInfo={fetchMerchantInfo}
            />
            <CreateAccountModal
                visible={showCreateAccountModal}
                toggleCreateAccountModal={toggleCreateAccountModal}
                merchant={merchant}
                fetchAllotedAccounts={fetchAllotedAccounts}
                isSubWallet={props.isSubWallet}
                selectedVirtualAccount={props.selectedVirtualAccount}
                fetchMerchantInfo={fetchMerchantInfo}
            />
            <LoadEditAccountModal
                visible={showEditAccountModal}
                merchant={merchant}
                editAccountModal={editAccountModal}
                toggleDetailsDrawer={props.toggleDetailsDrawer}
                account={selectedAccount}
                fetchAllotedAccounts={fetchAllotedAccounts}
                fetchMerchantInfo={fetchMerchantInfo}
            />

        </EaseDrawer>
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
})

const mapDispatchToProps = dispatch => ({
    updateCurrentUser: user => dispatch(updateCurrentUserAction(user))
})

export default connect(mapStateToProps, mapDispatchToProps)(AllotedConnectedBankingDrawer);